<template>
  <div>
    <div id="search">
      <el-row style="height: 40px">
        <el-col>
          备注旗帜：<el-select v-model="sellerFlag" size="mini" style="width: 100px" placeholder="请选择">
          <el-option
            v-for="item in flagOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

          <el-button type="primary" size="small" @click="getTjfzzData" style="margin-right: 60px">搜索</el-button>

          备注旗帜：<el-select v-model="changeFlag" size="mini" style="width: 100px" placeholder="请选择">
          <el-option
            v-for="item in flagOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

          <el-button type="primary" size="small" @click="updateMemo">上传备注</el-button>
        </el-col>
      </el-row>
    </div>
    <el-button type="primary" size="mini" @click="hide">全屏显示/恢复</el-button>
    <el-row>
      <el-col :span="24">
        <el-table border  style="font-size: 12px" :data="tjfzzData" :header-cell-style="{background:'#F2F6FC',color:'#000'}">

          <el-table-column  prop="tid" label="订单号" width="200px"></el-table-column>
          <el-table-column  prop="" label="快递单号" width="100px"></el-table-column>
          <el-table-column  prop="" label="物流公司名称" width="120px"></el-table-column>
          <el-table-column  prop="sellerMemo" label="货号地址备注" width="240px"></el-table-column>
          <el-table-column  prop="orderpay" label="实付单价" width="160px"></el-table-column>
          <el-table-column  prop="price" label="单价" width="160px"></el-table-column>
          <el-table-column label="图1"  width="100px">
            <template slot-scope="scope" >
              <img  width="60px" height="100px" :src="scope.row.pic1+'_200x200.jpg'" />
            </template>
          </el-table-column>
          <el-table-column label="图2"  width="100px">
            <template slot-scope="scope" >
              <img  width="60px" height="100px" :src="scope.row.pic2+'_200x200.jpg'" />
            </template>
          </el-table-column>
          <el-table-column label="图3"  width="100px">
            <template slot-scope="scope" >
              <img  width="60px" height="100px" :src="scope.row.pic3+'_200x200.jpg'" />
            </template>
          </el-table-column>
          <el-table-column label="图4"  width="100px">
            <template slot-scope="scope" >
              <img  width="60px" height="100px" :src="scope.row.pic4+'_200x200.jpg'" />
            </template>
          </el-table-column>
          <el-table-column  prop="maskNick" label="买家" width="160px"></el-table-column>
          <el-table-column  prop="receiverInfo" label="收货人信息" width="240px"></el-table-column>
          <el-table-column  prop="hhCON" label="货号" width="160px"></el-table-column>
          <el-table-column  prop="buyerMessage" label="买家留言" width="160px"></el-table-column>

        </el-table>
      </el-col>
    </el-row>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

  export default {
    name: "Tjfzz",
    data() {
      return {
        display:1,
        sellerFlag:-1,
        changeFlag:-1,
        flagOpto:[{value:-1,label:'全部'},{value:0,label:'0-灰色'},{value:1,label:'1-红色'},{value:2,label:'2-黄色'},{value:3,label:'3-绿色'},{value:4,label:'4-蓝色'},{value:5,label:'5-紫色'}],
        tjfzzData: [],
        pageObject: {
          pageCurrent: 1,
          rowCount: 0,
          pageSize: 10
        },
      }
    },
    methods: {
      hide:function(){
        this.display++;
        if(this.display % 2 == 0){
          window.document.getElementById("left").style.display = 'none';
          window.document.getElementById("top").style.display = 'none';
          window.document.getElementById("search").style.display = 'none';
        }else {
          window.document.getElementById("left").style.display = 'block';
          window.document.getElementById("top").style.display = 'block';
          window.document.getElementById("search").style.display = 'block';
        }

      },
      indexMethod(index) {
        return index + 1;
      },
      //改变pageSize
      handleSizeChange: function (val) {
        this.pageObject.pageSize = val;
        this.getTjfzzData();
      },
      //当前页面改变
      handleCurrentChange: function (val) {
        this.pageObject.pageCurrent = val;
        this.getTjfzzData();
      },
      getTjfzzData: function () {
        let param = {
          nick: storage.get("nick"),
          sellerFlag: this.sellerFlag,
        }
        $api.post("/custom/tjfzz", param, response => {
          let dataResult = response.data;
          if (dataResult.state == 1 && dataResult.message == "ok") {
            this.tjfzzData = dataResult.data.tjfzz;
            let pageObject = dataResult.data.pageObject;
            this.pageObject.rowCount = pageObject.rowCount;
            this.pageObject.pageSize = pageObject.pageSize;
          } else {
            this.$message.error(dataResult.message);
            this.$router.replace({name: "Index"});
          }
        })
      },
      updateMemo: function () {
        let param = {
          nick: storage.get("nick"),
          sellerFlag: this.sellerFlag,
          changeFlag: this.changeFlag,
        }
        $api.post("/custom/tjfzzUpdateMemo", param, response => {
          let dataResult = response.data;
          console.log(dataResult);
          if (dataResult.state == "1" && dataResult.message == "ok") {
            this.$message.success("上传备注成功。")
          } else {
            this.$message.error(dataResult.message);
            this.$router.replace({name: "Index"});
          }
        })
      }
    },
    mounted() {
      this.getTjfzzData();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/Tjfzz.vue